

import {
    Box,
} from '@chakra-ui/react';

import AllTicketsTable from "../tables/AllTicketsTable";
import EnterpriseReportSummary from "../../reports/EnterpriseReportSummary";
import { buildTicketVolumeInsights } from "../../../store/reportEnterpriseInsights";

const Tickets = ({
    reportIndex,
    data,
    renderConfig,
}) => {
    const insights = buildTicketVolumeInsights([data], { scopeLabel: "Organization" });

    return (
        <Box>
            <EnterpriseReportSummary
                title="Ticket Operations Summary"
                kpis={insights.kpis}
                tables={insights.tables}
                notes={insights.notes}
            />
            <AllTicketsTable 
            table={[data]} 
            chart={data.chart} 
            reportIndex={reportIndex} 
            renderConfig={renderConfig}
        />
        </Box>
    );
};
export default Tickets;
